import { DataBean } from "../DataBean";


export class DOCFolder extends DataBean {

    public async getDOCFolder(iddocfolder: number): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCFolder_getDOCFolder_Number", [iddocfolder]);
    }

    public async getDOCFolderCatalogPorPropiedades(propiedades: Record<string, any>, maxRows: number): Promise<any> {
        return this.getCustomService("Forms", "java.util.List_getDOCFolderCatalogPorPropiedades_java.util.Map_Number", [propiedades, maxRows]);
    }

    public async updateDOCFolder(bean: Record<string, any>): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCFolder_updateDOCFolder_com.advantage.forms.bean.DOCFolder", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.advantage.forms.bean.DOCFolder"
            }
        ]);
    }

}